module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0146.jpg?v=5fa2f650";